import { createFileRoute } from '@tanstack/react-router'
import { CorporateDashboard } from '@/features/corporate'

export const Route = createFileRoute('/corporate')({
  component: CorporateDashboard,
})
